import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { Paging, RequestOption } from 'src/app/shared/model/common.model';
import { MatSelectModel } from 'src/app/shared/model/score-card.model';
import { ScorecardSettingService } from 'src/app/shared/service/scorecard-setting.service';

@Component({
  selector: 'app-scorecard-setting',
  templateUrl: './scorecard-setting.component.html',
  styleUrls: ['./scorecard-setting.component.scss']
})
export class ScorecardSettingComponent implements OnInit {


  displayedColumns = ['parent', 'gsl', 'year', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  requestOption: RequestOption = new RequestOption();
  search = '';
  roles: any[] = [];
  role = '';
  sortTimeoutInstance: any;
  scoreCardFormGroup: FormGroup;
  years: any[] = [];
  gsls: any[] = [];
  yearSelected: MatSelectModel[] = [];
  gslSelected: MatSelectModel[] = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private spinner: Spinner,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    private scorecardSettingService: ScorecardSettingService
  ) {
    this.buildForm();
    this.getYears();
  }

  ngOnInit() {
    this.buildForm();
    this.loadDataTable();
  }

  private buildForm() {
    this.scoreCardFormGroup = new FormGroup({
      search: new FormControl(''),
      years: new FormControl(''),
    });
  }

  public getListDataTable() {
    this.spinner.show();
    this.scorecardSettingService.getData(this.requestOption, this.scoreCardFormGroup.getRawValue()).subscribe(res => {
      this.spinner.hide();
      if (res.data.content) {
        this.dataSource.data = res.data.content;
        const rq: RequestOption = { ...this.requestOption };
        rq.pagingOptions.totalPages = res.data.totalPages;
        rq.pagingOptions.numberOfElements = res.data.numberOfElements;
        rq.pagingOptions.totalElements = res.data.totalElements;
        this.requestOption = rq;
      }
    });
  }

  public getYears() {
    this.spinner.show();
    this.scorecardSettingService.getYears().subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.years = res.data.map(item => ({value: item, name: item}));
        this.yearSelected = this.years;
      }
    }, err => this.spinner.hide());
  }


  public onChangeRequestOption(event: RequestOption) {
    this.requestOption = event;
    this.getListDataTable();
  }

  public initialRequestOption() {
    this.requestOption.pagingOptions.totalPages = 0;
    this.requestOption.pagingOptions.numberOfElements = 0;
  }

  public loadDataTable(goToFirstPage?: boolean) {
    if (goToFirstPage) {
      this.requestOption.pagingOptions = new Paging(this.requestOption.pagingOptions.size);
      this.initialRequestOption();
    }
    this.getListDataTable();
  }

  public searchData() {
    this.scoreCardFormGroup.controls.search.value.trim();
    this.requestOption.pagingOptions.number = 0;
    this.getListDataTable();
  }

  public filterData(value) {
    const data = value.slice();
    if (data[0] === 'All') {
      data.shift();
      this.scoreCardFormGroup.controls.years.setValue([]);
    } else {
      this.scoreCardFormGroup.controls.years.setValue(data.map(item => item.value));
    }
  }

  public addNewSetting() {
    this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ADD_SCORECARD_SETTING]);
  }

  public edit(parent, year, gsl) {
    const parentURI = encodeURI(parent);
    if (gsl) {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-scorecard-setting', parentURI, year, gsl]);
    } else {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-scorecard-setting', parentURI, year]);
    }
  }

  public deleteSetting(parent, year, gsl) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_SETTING
      }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.spinner.show();
        this.scorecardSettingService.deleteSetting(parent, year, gsl).subscribe((res: any) => {
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.DELETE_SETTING);
            this.getListDataTable();
          }
        });
      }
    });
  }

  sortData(sort: Sort) {
    if (this.sortTimeoutInstance) {
      clearTimeout(this.sortTimeoutInstance);
    }
    this.sortTimeoutInstance = setTimeout(() => {
      this.requestOption.pagingOptions.sort.sortBy = sort.active;
      this.requestOption.pagingOptions.sort.sortOrder = sort.direction;
      this.getListDataTable();
    }, 500);
  }
}
